module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Ft3Ppj/tc-custom/9781452100197.jpg?1721404776897",
      "alt": "This image is the cover for the book Fire It Up"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Fire It Up\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The "), _c('i', [_vm._v("New York Times")]), _vm._v(" bestselling authors of "), _c('i', [_vm._v("Mastering the Grill")]), _vm._v(" present 400 recipes that focus on the joy of great ingredients.")]), _c('br'), _c('br'), _vm._v("Fire It Up shows today’s cooks how to buy, prepare, and grill more than 290 ingredients from beef and pork to chicken, fish, vegetables, fruit, and more. Handy charts explain different cuts, best grilling methods, and perfect doneness. Insider tips throughout the volume solve dozens of dinnertime dilemmas, while gorgeous color photos and useful illustrations bring it all to life. "), _c('br'), _c('br'), _vm._v("With more than 400 delicious recipes and 160 winning rubs, brines, marinades, and sauces, Fire It Up makes it easy for everyone to become a backyard grill master—no matter what’s on the menu. Jam packed with recipes, tips, and illustrations, Fire It Up is THE grill book for this summer.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Andrew Schloss, David Joachim, Alison Miksch\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Andrew Schloss is the author of 10 cookbooks. He lives in eastern Pennsylvania.David Joachim is a Pennsylvania-based journalist who has collaborated on more than 25 cookbooks.Alison Miksch is a food and lifestyle photographer living in eastern Pennsylvania.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0